
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import { Component, Vue, Watch } from 'vue-property-decorator';
    import moment from 'moment';
    import swal from 'sweetalert2';
    import { AxiosResponse } from 'axios';
    import Arbeitsplatz from '@/types/Arbeitsplatz';
    import ArbeitsplatzhinweisDialog from '@/components/ArbeitsplatzhinweisDialog.vue';
    import DruckhinweisDialog from '@/components/DruckhinweisDialog.vue';
    import Elgaimpfstoffe from '@/types/ElgaImpfstoffe';
    import Impfstatistik from '@/components/Statistik/Impfstatistik.vue';
    import ImpfstelleDetail from '@/components/Impfstelle/ImpfstelleDetail.vue';
    import JahrgangsImpfstatistik from '@/components/Statistik/JahrgangsImpfstatistik.vue';
    import OffeneVerrechnung from '@/components/Statistik/OffeneVerrechnung.vue';
    import Patientenauswertung from '@/components/Statistik/Patientenauswertung.vue';
    import Rechnungen from '@/components/Statistik/Rechnungen.vue';
    import OffeneSalden from '@/components/Statistik/OffeneSalden.vue';
    import Reisestatistik from '@/components/Statistik/Reisestatistik.vue';
    import Stipas from '@/components/Statistik/Stipas.vue';
    import SystemdatenDetail from '@/components/Systemdaten/SystemdatenDetail.vue';
    import Tagesjournal from '@/components/Statistik/Tagesjournal.vue';
    import Umsatzstatistik from '@/components/Statistik/Umsatzstatistik.vue';
    import User from '@/types/User';
    import UsersDetail from '@/components/Users/UsersDetail.vue';
    import Wavm from '@/components/Statistik/Wavm.vue';
    import createDraggableDialogsManager from '@/helper/DraggableDialogs';
    import jspm from '@/services/PrintManager';
    import { DataResponse } from '@/types';
    import { base } from '@/services/Api';
    import { confirmSwal, warningSwal } from '@/helper/swals';
    import Patientenmitimpfung from '@/components/Statistik/Patientenmitimpfung.vue';
    import Patientenstatistik from '@/components/Statistik/Patientenstatistik.vue';
    import Patientenmitleistungen from '@/components/Statistik/Patientenmitleistungen.vue';
    import Navigation from '@/components/Navigation/Navigation.vue';
    import NavigationDrawer from '@/components/Navigation/NavigationDrawer.vue';
    import NavigationPalette from '@/components/Navigation/NavigationPalette.vue';
    import Sammelrechnung from '@/views/Sammelrechnung.vue';
    import Impfauswertung from '@/components/Statistik/Impfauswertung.vue';
    import Patientenstatistik_Detailiert from '@/components/Statistik/Patientenstatistik_Detailiert .vue';
    import Patientenstatistik_Studenten from '@/components/Statistik/Patientenstatistik_Studenten .vue';
    import Preislisten from '@/components/Statistik/Preislisten .vue';

    @Component({
        components: {
            Preislisten,
            Patientenstatistik_Studenten,
            Patientenstatistik_Detailiert,
            Impfauswertung,
            Sammelrechnung,
            Patientenmitleistungen,
            Patientenmitimpfung,
            ArbeitsplatzhinweisDialog,
            DruckhinweisDialog,
            Impfstatistik,
            ImpfstelleDetail,
            JahrgangsImpfstatistik,
            OffeneVerrechnung,
            Patientenauswertung,
            Rechnungen,
            Reisestatistik,
            Stipas,
            SystemdatenDetail,
            Tagesjournal,
            Umsatzstatistik,
            UsersDetail,
            Wavm,
            OffeneSalden,
            Patientenstatistik,
            Navigation,
            NavigationDrawer,
            NavigationPalette,
        },
        computed: {
            ...mapState('authentication', [
                'user',
                'status',
                'initialized',
                'impfstelle_id',
                'impfstelle',
                'getImpfstellen',
                'impfstellen',
                'impfstelle',
                'arbeitsplaetze',
            ]),
            ...mapState('authentication', { impfstelleDialog: 'dialog' }),
            ...mapState('patient', { sammelrechnungDialogs: 'dialogs'}),
            ...mapState('systemdaten', { systemdatenDialog: 'dialog' }),
            ...mapState('authentication', { authenticationLoaders: 'loaders' }),
            ...mapGetters('authentication', ['getImpfstelleName', 'arbeitsplatz', 'isAllowed', 'getSystemEinstellung']),
            ...mapState('statistik', { statistikDialog: 'dialog', statistikLoaders: 'loaders' }),
            ...mapState('users', { usersDialog: 'dialogs' }),
            ...mapState('globals', ['printers']),
            ...mapState('application', ['version']),
        },
        methods: {
            ...mapActions('globals', ['loadTitle']),
            ...mapActions('patient', [
                'patientDetail',
                'searchPatient',
                'patientNew',
                'patientNeuMitAdresse',
                'rechnungpdf',
            ]),
            ...mapActions('authentication', ['start', 'updateImpfstelle', 'logout']),
            ...mapActions('session', ['setSelectedArbeitsplatz']),
            ...mapActions('impfstoff', ['setDialogImpfstoffeDetail']),
            ...mapActions('reise', ['loadReiseziele', 'loadReisearten']),
            ...mapActions('systemdaten', ['setSystemdatenDialogDetail']),
            ...mapActions('statistik', { setStatistik: 'setDialogs' }),
            ...mapActions('globals', ['setPrinterStatus']),
            ...mapMutations('patient', ['setDialogRechnung', 'setDialogSammelrechnung']),
            ...mapMutations('authentication', ['setDialogImpfstelleDetail']),
            ...mapMutations('globals', ['setDialogDruckhinweis', 'setPrintData', 'setDialogArbeitsplatzhinweis']),
            ...mapMutations('users', { setUsersDialog: 'setDialogs' }),
            ...mapMutations('impfstoff', ['setElgaimpfstoffe']),
            ...mapActions('application', ['startWorker', 'stopWorker', 'rerollVersion']),
            ...mapMutations('application', { initApplication: 'initialized' }),
        },
    })
    export default class App extends Vue {
        public initialized!: boolean;
        public user!: User | null;
        public arbeitsplaetze!: Arbeitsplatz[];
        public start!: () => void;
        public setPrinterStatus!: (status: string) => void;
        public logout!: () => void;
        public setElgaimpfstoffe!: (impfstoffe: Partial<Elgaimpfstoffe>[]) => void;
        public initApplication!: (value: boolean) => void;
        public startWorker!: () => void;
        public stopWorker!: () => void;
        public rerollVersion!: () => void;
        public resetLogin!: () => void;

        public sessionTimer = 0;
        public userSession = '';
        public draggableDialogsManager = createDraggableDialogsManager();
        public drawer = false;
        public rerollVersionDone = false;

        public mounted(): void {
            this.start();
            if (process.env.VUE_APP_DISABLE_PRINT_MANAGER !== '1') {
                jspm.start();
            }
            this.draggableDialogsManager.init();
            this.startWorker();
            this.initApplication(true);
        }

        public destroyed(): void {
            window.clearTimeout(this.sessionTimer);
            this.draggableDialogsManager.destroy();
        }

        @Watch('status.loggedIn')
        public onChangeStatusLoggedIn(loggedIn: boolean): void {
            if (loggedIn) {
                window.clearTimeout(this.sessionTimer);
                this.sessionTimer = window.setTimeout(this.checkUserSession, 1000);
            }
        }

        public checkUserSession(): void {
            if (this.user?.elga_access) {
                const now = moment();
                const exp = moment(this.user.elga_login_expiration);
                const duration = moment.duration(exp.diff(now));
                const hh = duration.hours();
                const mm = duration.minutes();
                const ss = duration.seconds();

                if (ss >= 0) {
                    if (hh === 0 && mm === 15 && ss === 0) {
                        warningSwal(
                            'Ablaufende Sitzung',
                            'ELGA Sitzung wird in 15 minuten ablaufen. Bitte melden Sie sich neu an.'
                        );
                    }

                    this.userSession = [hh, mm, ss]
                        .map((time) => time.toString().padStart(2, '0'))
                        .join(':');

                    this.sessionTimer = window.setTimeout(this.checkUserSession, 1000);
                } else {
                    this.userSession = 'abgelaufen';
                    warningSwal(
                        'Sitzung Abgelaufen',
                        'ELGA Sitzung ist abgelaufen. Bitte melden Sie sich neu an.'
                    );
                }
            } else {
                this.userSession = '';
            }
        }

        public get appVersion(): string | undefined {
            return process.env.VUE_APP_VERSION;
        }

        public get devprod(): string | undefined {
            return process.env.VUE_APP_DEVPROD;
        }

        public get testsystem(): string | undefined {
            return this.user?.testsystem ? 'Testsystem' : '';
        }

        public goto(route: string): void {
            this.drawer = false;

            if (this.$router.currentRoute.path !== route) {
                this.$router.push(route);
            }
        }

        public onClickHome(): void {
            if (!this.initialized) {
                return;
            }

            const home = this.user?.hasRoles(['lager']) && !this.user?.hasRoles(['anwender', 'admin', 'system'])
                ? '/lager'
                : '/';

            if (this.$router.currentRoute.path !== home) {
                this.$router.push(home);
            }
        }

        public created(): void {
            // https://github.com/vuejs/vue-router/issues/1849
            if ('-ms-scroll-limit' in document.documentElement.style &&
                '-ms-ime-align' in document.documentElement.style) {
                window.addEventListener('hashchange', () => {
                    const currentPath = window.location.hash.slice(1);
                    if (this.$route.path !== currentPath) {
                        this.$router.push(currentPath);
                    }
                }, false);
            }
        }

        public printerStatus(): string {
            return 'PrintManager: ' + jspm.printerStatus();
        }

        public openTab(route: string): void {
            window.open(base + route, '_blank');
        }

        @Watch('version')
        public onChangeVersion(): void {
            if (this.rerollVersionDone) {
                return;
            }

            confirmSwal(
                'Neue Version verfügbar',
                'Soll die neue Version geladen werden? Ungespeicherte Daten gehen dabei verloren.',
            ).then((res) => {
                if (res.value) {
                    document.location.reload();
                } else {
                    this.rerollVersionDone = true;
                    this.rerollVersion();
                }
            });
        }

        public onClickLogout(): void {
            confirmSwal(
                'Abmelden',
                'Wollen Sie sich abmelden?',
                'Abmelden',
                'Abbrechen'
            ).then(({ isConfirmed }) => {
                if (isConfirmed) {
                    this.logout();
                }
            });
        }

        public clearApcuCache(): void {
            confirmSwal(
                'APCU',
                'Wollen Sie den APCU Cache leeren?',
                'Leeren',
                'Abbrechen'
            ).then(({ isConfirmed }) => {
                if (!isConfirmed) {
                    return;
                }

                swal.fire({
                    title: 'APCU',
                    html: 'Leerung gestartet...',
                    willOpen: () => {
                        const container = swal.getHtmlContainer();
                        if (!container) {
                            return;
                        }

                        type ApcuClearData = DataResponse<true>;

                        this.axios
                            .post('verwaltung/apcu/clear')
                            .then(({ data }: AxiosResponse<ApcuClearData>) => {
                                container.innerHTML =
                                    `<code style="white-space: pre">${JSON.stringify(data.body, null, 4)}</code>`;
                                container.style.textAlign = 'left';
                            })
                            .catch((error) => container.innerText = error?.message ?? error?.toString() ?? 'Fehler');
                    },
                    customClass: {
                        confirmButton: 'v-btn v-btn--depressed theme--light v-size--small primary',
                        cancelButton: 'v-btn v-btn--depressed theme--light v-size--small grey',
                    },
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: 'Schließen',
                    width: 'auto',
                });
            });
        }

        public syncTerminologien(): void {
            confirmSwal(
                'Terminologien',
                'Wollen Sie die Terminologien neu synchronisieren?',
                'Synchronisieren',
                'Abbrechen'
            ).then(({ isConfirmed }) => {
                if (!isConfirmed) {
                    return;
                }

                swal.fire({
                    title: 'Terminologien',
                    html: 'Synchronisierung gestartet...',
                    willOpen: () => {
                        const container = swal.getHtmlContainer();
                        if (!container) {
                            return;
                        }

                        type TerminologienSyncData = DataResponse<{
                            response?: string,
                            elgaimpfstoffe: Partial<Elgaimpfstoffe>[],
                            error?: string
                        }>;

                        this.axios
                            .post('verwaltung/terminologien/sync', null, { timeout: 5 * 60 * 1000 })
                            .then(({ data }: AxiosResponse<TerminologienSyncData>) => {
                                container.innerHTML = data.body.error ?? data.body.response ?? '';
                                container.style.textAlign = 'left';

                                if (data.body.elgaimpfstoffe?.length > 0) {
                                    this.setElgaimpfstoffe(data.body.elgaimpfstoffe);
                                }
                            })
                            .catch((error) => container.innerText = error?.message ?? error?.toString() ?? 'Fehler');
                    },
                    customClass: {
                        confirmButton: 'v-btn v-btn--depressed theme--light v-size--small primary',
                        cancelButton: 'v-btn v-btn--depressed theme--light v-size--small grey',
                    },
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: 'Schließen',
                    width: 'auto',
                });
            });
        }
    }
